import React, { useState } from "react";
import { Button } from "antd";
import classes from "./style/Component404.module.css";
import { Link } from "react-router-dom";

// анимация ошибки 404
const Component404 = () => {
  const [newStyle, setNewStyle] = useState(false);

  const styleCondition = (firstClassName: string, secondClassName: string) => {
    return newStyle === false ? firstClassName : secondClassName;
  };

  const getNewStyle = (bool: boolean) => {
    setNewStyle(bool);
  };
  setTimeout(getNewStyle, 1200, true);

  return (
    <div className={classes.mainWrapper}>
      <div className={classes.infoWrapper}>
        <h1 className={classes.title}>
          К сожалению, мы не смогли найти эту страницу
        </h1>
        <p className={classes.description}>
          Возможно, эта страница появится в будущем
        </p>
        <div className={classes.buttonWrapper}>
          <Link className={classes.menuLink} to="/">
            <Button className={classes.button} type="primary">
              Вернуться на список заявок
            </Button>
          </Link>
        </div>
      </div>

      <div className={classes.numsWrapper}>
        <div className={classes.numOneWrapper}>
          <div
            className={styleCondition(
              classes.numOneElement1,
              classes.numOneElement1Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numOneElement2,
              classes.numOneElement2Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numOneElement3,
              classes.numOneElement3Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numOneElement4,
              classes.numOneElement4Color
            )}
          ></div>
        </div>
        <div className={classes.numTwoWrapper}>
          <div
            className={styleCondition(
              classes.numTwoElement1,
              classes.numTwoElement1Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numTwoElement2,
              classes.numTwoElement2Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numTwoElement3,
              classes.numTwoElement3Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numTwoElement4,
              classes.numTwoElement4Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numTwoElement5,
              classes.numTwoElement5Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numTwoElement6,
              classes.numTwoElement6Color
            )}
          ></div>
        </div>
        <div className={classes.numThreeWrapper}>
          <div
            className={styleCondition(
              classes.numThreeElement1,
              classes.numThreeElement1Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numThreeElement2,
              classes.numThreeElement2Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numThreeElement3,
              classes.numThreeElement3Color
            )}
          ></div>
          <div
            className={styleCondition(
              classes.numThreeElement4,
              classes.numThreeElement4Color
            )}
          ></div>
        </div>
      </div>

      <div className={classes.numsWrapperMob}>404</div>
    </div>
  );
};

export default Component404;
